import type { HTMLAttributes, ReactNode } from "react";

export type BadgeVariant =
  | "default"
  | "success"
  | "warning"
  | "danger"
  | "ai"
  | "accent";

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: BadgeVariant;
  children: ReactNode;
};

export function Badge({
  variant = "default",
  className,
  children,
  ...rest
}: BadgeProps) {
  const variantClass = variant === "default" ? "" : `ax-badge--${variant}`;
  return (
    <span
      className={["ax-badge", variantClass, className].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </span>
  );
}
